<header
  [ngClass]="{
    'header--sticky': isSticky,
    'modal-open': modalsActive
  }"
  class="header"
>
  <div class="header__wrapper">
    <div
      *ngIf="logoSvgId ?? 'logo-tns-sng' as svgId"
      class="header__wrapper__logo {{ svgId }}"
    >
      <a routerLink="/">
        <ui-svg-icon
          [svgId]="svgId"
          iconClassName="icon-header--logo"
        ></ui-svg-icon>
      </a>
    </div>
  </div>
</header>
<div *ngIf="isPwaBanner$ | async" class="header__pwa-banner">
  <cp-pwa-banner
    (bannerClosed)="onBannerClose()"
    (downloadClicked)="onInstallClicked()"
  ></cp-pwa-banner>
</div>

<ui-progress-meter
  [isMeterActive]="isProgressMeterActive"
  [isSticky]="isSticky"
></ui-progress-meter>
